import { Accordion, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useSoldSNStore } from "../../../store/soldsn.store";
import { useFoundSNList } from "../../../hook/partner/soldsnsearch.partner.hook";
import { useAuthStore } from "../../../store/auth.store";
import { NavLink } from "react-router";
import { useTranslation } from "../../../hooks/useTranslation";

export default function SoldSNSearch({
  showModal,
  doCloseModal,
  showSNDirectly,
  hideExternal,
}) {
  const { t } = useTranslation();
  const token = useAuthStore((state) => state.token);
  const [sn, setSN] = useState(null);
  const [showSN, setShowSN] = useState(false);
  const [doSearch, setDoSearch] = useState(null);
  const foundSNList = useSoldSNStore((state) => state.foundSNList);
  const searchMutation = useFoundSNList();

  useEffect(() => {
    if (sn && sn !== "") {
      console.log("hledej...");
      searchMutation.mutate({ token, sn });
    }
  }, [doSearch]);

  useEffect(() => {
    if (showSNDirectly && !showSN) {
      setSN(showSNDirectly);
      setDoSearch(true);
    }
  }, []);

  useEffect(() => {
    if (showSNDirectly && foundSNList && foundSNList[0]) {
      setShowSN(foundSNList[0]);
    }
  }, [foundSNList]);

  return (
    <>
      <Modal
        show={showSN}
        onHide={() => {
          setShowSN(false);
          if (hideExternal) {
            hideExternal();
          }
        }}
      >
        {!searchMutation.isLoading ? (
          <Modal.Header closeButton>{t("common.detail")} {showSN.sn}</Modal.Header>
        ) : (
          <Modal.Header closeButton>{t("common.searching")}...</Modal.Header>
        )}
        {searchMutation.isLoading ? (
          <Modal.Body>
            <div className="alert alert-info">{t("soldSn.searchingSnInfo")}</div>
          </Modal.Body>
        ) : (
          <Modal.Body>
            {showSN?.opportunity_list && (
              <span
                className={
                  "badge badge-secondary badge-vendor-" +
                  showSN?.opportunity_list[0]?.product.vendor_id
                }
              >
                {showSN?.opportunity_list[0]?.product.vendor_name}
              </span>
            )}
            {showSN?.contract_list && (
              <div>
                <h3 className="mt-3">Contract IDs</h3>
                <Accordion>
                  {showSN.contract_list.map((contract) => (
                    <Accordion.Item
                      key={contract.contractNumber}
                      eventKey={contract.contractNumber}
                    >
                      <Accordion.Header>
                        {contract.contractNumber}:{" "}
                        {new Date(contract.creationDate).toLocaleDateString()}
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="row">
                          <div className="col">
                            <strong>{t("soldSn.creationDate")}</strong>
                            <div>
                              {new Date(
                                contract.creationDate
                              ).toLocaleDateString()}
                            </div>
                          </div>
                          <div className="col">
                            <strong>{t("deals.registrationDate")}</strong>
                            <div>
                              {new Date(
                                contract.registrationDate
                              ).toLocaleDateString()}
                            </div>
                          </div>
                          <div className="col">
                            <strong>{t("common.status")}</strong>
                            <div>{contract.status}</div>
                          </div>
                        </div>
                        <div className="pt-3">
                          <strong>{t("soldSn.support")}</strong>
                          {contract.support.map((support, sindex) => (
                            <div
                              className="row py-2 mt-2"
                              style={{ borderTop: "solid 1px #ddd" }}
                            >
                              <div className="col">
                                {support.supportType}: {support.supportLevel}
                              </div>
                              <div className="col">
                                {new Date(
                                  support.startDate
                                ).toLocaleDateString()}
                                {" - "}
                                {new Date(support.endDate).toLocaleDateString()}
                              </div>
                            </div>
                          ))}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            )}
            {showSN?.opportunity_list && (
              <div>
                <h3 className="mt-5">{t("soldSn.businessOpportunities")}</h3>
                <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable">
                  <thead>
                    <tr>
                      <th>{t("opportunities.opportunity")}</th>
                      <th>{t("common.product")}</th>
                      <th>{t("common.expiration")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {showSN.opportunity_list.map((op) => (
                      <tr key={op.opportunity_id}>
                        <td>
                          <NavLink to={"/prilezitost/" + op.opportunity_id}>
                            {op.opportunity_id}
                          </NavLink>
                        </td>
                        <td>
                          {op.product.product_family}, {op.product.name}
                        </td>
                        <td>
                          {op.expiration_date !== "0000-00-00"
                            ? new Date(op.expiration_date).toLocaleDateString()
                            : "n/a"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </Modal.Body>
        )}
      </Modal>
      <Modal show={showModal} onHide={() => doCloseModal()}>
        <Modal.Header closeButton>{t("soldSn.searchSn")}</Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-8">
              <input
                type="text"
                className="form-control"
                placeholder={t("soldSn.searchedSn")}
                value={sn}
                onChange={(e) => setSN(e.target.value)}
              />
            </div>
            <div className="col-4">
              <button
                className="btn btn-primary w-100"
                disabled={!sn || sn === ""}
                onClick={() => setDoSearch(doSearch + 1)}
              >
                {t("common.search")}
              </button>
            </div>
          </div>
          {searchMutation.isLoading ? (
            <div className="alert alert-info mt-3">
              {t("soldSn.searchingSerialNumber", { sn })}...
            </div>
          ) : foundSNList?.error ? (
            <div className="alert alert-danger mt-3">{foundSNList.error}</div>
          ) : (
            foundSNList && (
              <>
                <div className="border-top border-bottom py-3 my-3">
                  {t("soldSn.numberOfFoundSn")}: {foundSNList?.length}
                </div>
                <div style={{ maxHeight: "60vh", overflow: "auto" }}>
                  {foundSNList?.map((sn) => (
                    <div className="card mb-3">
                      <div
                        className="card-header"
                        style={{ backgroundColor: "#efefef" }}
                      >
                        <h3 className="card-title">{sn.sn}</h3>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-6">
                            <span className="badge badge-info mb-3">
                              {sn.opportunity_list[0].product.vendor_name}
                            </span>
                            <div>
                              {
                                sn.opportunity_list.find(
                                  (snl) =>
                                    snl.opportunity_id ===
                                    sn.first_opportunity_id
                                ).product.product_family
                              }
                              ,{" "}
                              {
                                sn.opportunity_list.find(
                                  (snl) =>
                                    snl.opportunity_id ===
                                    sn.first_opportunity_id
                                ).product.name
                              }
                              <span className="ms-3 badge badge-info badge-outline">
                                {
                                  sn.opportunity_list.find(
                                    (snl) =>
                                      snl.opportunity_id ===
                                      sn.first_opportunity_id
                                  ).product.sku
                                }
                              </span>
                            </div>
                          </div>
                          <div className="col-6">
                            <strong>{sn.company.name}</strong>
                            <div>
                              {sn.company.street}, {sn.company.city}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-footer">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() => setShowSN(sn)}
                        >
                          {t("common.detail")}
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
